const { CATEGORIES } = require('./constants');

const EXTRA_CATEGORY_LABELS = {
  music: 'Music',
  study: 'Study',
  travel: 'Travel',
};

function categoryLabel(category) {
  const id = String(category || '').trim();
  if (!id) return '';
  const fromList = CATEGORIES.find((c) => c.id === id);
  if (fromList) return fromList.label;
  if (EXTRA_CATEGORY_LABELS[id]) return EXTRA_CATEGORY_LABELS[id];
  return id.charAt(0).toUpperCase() + id.slice(1);
}

/**
 * Short line for share text when the user left description blank (category · place · time).
 * @param {{ category?: string, dateTime?: string|Date, location?: { address?: string } }} activity
 */
function buildActivityShareDetailLine(activity) {
  const parts = [];
  const cat = categoryLabel(activity.category);
  if (cat) parts.push(cat);
  const addr = (activity.location?.address || '').trim();
  if (addr) {
    const short = addr.split(',')[0].trim().slice(0, 72);
    if (short) parts.push(short);
  }
  if (activity.dateTime) {
    try {
      const d = new Date(activity.dateTime);
      if (!Number.isNaN(d.getTime())) {
        parts.push(
          d.toLocaleString('en-US', {
            weekday: 'short',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
          })
        );
      }
    } catch {
      // ignore
    }
  }
  return parts.filter(Boolean).join(' · ');
}

/**
 * Full OG / meta description when `activity.description` is empty.
 * @param {{ title?: string, category?: string, dateTime?: string|Date, location?: { address?: string } }} activity
 */
function buildActivityOgDescription(activity) {
  const desc = (activity.description && String(activity.description).trim()) || '';
  if (desc) return desc;
  const title = (activity.title || 'Vibe').trim();
  const detail = buildActivityShareDetailLine(activity);
  if (detail) return `${title} — ${detail}. View on PlayFynd.`;
  return `Join "${title}" on PlayFynd.`;
}

module.exports = {
  categoryLabel,
  buildActivityShareDetailLine,
  buildActivityOgDescription,
};
